import React, { useEffect, useState } from 'react';
import {
    ButtonBase,
    Box,
    Typography,
} from '@mui/material';
import { StudentRegistration, TeacherRegistration } from './';

export default function Registration() {
    return (<StudentRegistration />);
}
